import { TFunction } from 'i18next';
import { FC, ReactNode } from 'react';

const HEADER_CELL_WIDTH = '4.5rem';
const HEADER_CELL_CLASS = `
  flex-none flex items-center justify-center 
  border-r border-gray-300 p-1 text-center leading-tight
`;

const HeaderCell: FC<{ children: ReactNode; width?: string }> = ({ children, width }) => (
  <div className={HEADER_CELL_CLASS} style={{ width: width ?? HEADER_CELL_WIDTH }}>
    {children}
  </div>
);

const HeaderGroup: FC<{ title: ReactNode; colSpan: number; children: ReactNode }> = ({
  title,
  colSpan,
  children,
}) => (
  <div
    className="flex flex-none flex-col border-r border-gray-300 text-center"
    style={{ width: `calc(${HEADER_CELL_WIDTH} * ${colSpan})` }}
  >
    <div className="border-b border-gray-300 bg-gray-200/50 py-1 font-semibold">{title}</div>
    <div className="flex h-full font-semibold">{children}</div>
  </div>
);

export const BusinessTableHeader = ({ t }: { t: TFunction }) => {
  return (
    <div className="flex min-h-[7.5rem] border-b border-gray-300 bg-gray-100 text-left text-xs font-semibold">
      {' '}
      {/* 120px, 11px -> text-xs */}
      <HeaderCell>{t('wards.common.salesOffice')}</HeaderCell>
      <HeaderCell>{t('wards.common.section')}</HeaderCell>
      <HeaderCell>{t('wards.desktop.summary.common.unitsUnderService')}</HeaderCell>
      <HeaderCell>{t('wards.desktop.summary.common.withSeismometers')}</HeaderCell>
      <HeaderGroup title={t('wards.desktop.summary.common.monitoringAlarm')} colSpan={4}>
        <HeaderCell>{t('wards.desktop.summary.common.targets')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.collected')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.failed')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.seismoOp1')}</HeaderCell>
      </HeaderGroup>
      <HeaderGroup title={t('wards.desktop.summary.common.excluded')} colSpan={3}>
        <HeaderCell>{t('wards.desktop.summary.common.reqConfirmation')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.confirmed')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.seismoOp2')}</HeaderCell>
      </HeaderGroup>
      <HeaderGroup title={t('wards.desktop.summary.common.entrapped')} colSpan={3}>
        <HeaderCell>{t('wards.desktop.summary.common.occurrences')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.rescues')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.rescueRate')}</HeaderCell>
      </HeaderGroup>
      <HeaderGroup title={t('wards.desktop.summary.common.seismoOp')} colSpan={6}>
        <HeaderCell>{t('wards.desktop.summary.common.stopped')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.restored')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.restoredRate')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.tempRestored')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.fullRestored')}</HeaderCell>
        <HeaderCell>{t('wards.desktop.summary.common.fullRate')}</HeaderCell>
      </HeaderGroup>
      <HeaderCell>{t('wards.desktop.summary.common.stopAndGo')}</HeaderCell>
      <HeaderCell>{t('wards.desktop.summary.common.physicalDamage')}</HeaderCell>
      <HeaderCell>{t('wards.desktop.summary.common.powerOutage')}</HeaderCell>
      <HeaderCell>{t('wards.desktop.summary.common.onCall')}</HeaderCell>
      <HeaderCell>{t('wards.desktop.summary.common.predictedStop')}</HeaderCell>
    </div>
  );
};
